import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type {
  ConsultarRascunhosParams,
  CreateProcessoPayload,
  EtapaProcesso,
  ProcessoDetalhe,
  ProcessoStatus,
  UpdateProcessoPayload,
} from '@/types/processos/processoStoreTypes';

import { processosService } from './services';

export const listarProcessos = createAsyncThunk(
  'processos/listar',
  async (
    params:
      | {
          search?: string;
          status?: ProcessoStatus;
          categoriaId?: string;
          setorId?: string;
          page?: number;
          limit?: number;
        }
      | undefined,
    { rejectWithValue },
  ) => {
    try {
      return await processosService.listar(params);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const consultarRascunhos = createAsyncThunk(
  'processos/consultarRascunhos',
  async (params: ConsultarRascunhosParams | undefined, { rejectWithValue }) => {
    try {
      return await processosService.listar({ ...params, status: 'RASCUNHO' });
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarProcessoPorId = createAsyncThunk<ProcessoDetalhe, string>(
  'processos/buscarPorId',
  async (id, { rejectWithValue }) => {
    try {
      return await processosService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as ProcessoDetalhe;
    }
  },
);

export const criarProcesso = createAsyncThunk<ProcessoDetalhe, CreateProcessoPayload>(
  'processos/criar',
  async (payload, { rejectWithValue }) => {
    try {
      return await processosService.criar(payload);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as ProcessoDetalhe;
    }
  },
);

export const atualizarProcesso = createAsyncThunk<
  ProcessoDetalhe,
  { id: string; dados: UpdateProcessoPayload }
>('processos/atualizar', async ({ id, dados }, { rejectWithValue }) => {
  try {
    return await processosService.atualizar(id, dados);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as ProcessoDetalhe;
  }
});

export const atualizarEtapa = createAsyncThunk<
  ProcessoDetalhe,
  { id: string; etapa: EtapaProcesso }
>('processos/atualizarEtapa', async ({ id, etapa }, { rejectWithValue }) => {
  try {
    return await processosService.patchEtapa(id, etapa);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as ProcessoDetalhe;
  }
});

export const removerProcesso = createAsyncThunk<string, string>(
  'processos/remover',
  async (id, { rejectWithValue }) => {
    try {
      await processosService.remover(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as string;
    }
  },
);
